module.exports = __webpack_public_path__ + "img/solution-farmer-img4.fee49a06.png";